import styled from 'styled-components';

import { colors } from 'config/theme';

export const AlertWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 40px 45px;
  color: black;
`;

export const HR = styled.hr`
  clear: both;
  display: block;
  width: 100%;
  border: 1px solid ${colors.lightGray};
  height: 2px;
  margin-top: 30px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row;
  margin: 20px;
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 31.2px;
  text-align: center;
`;

export const Text = styled.span`
  font-size: 22px;
  font-weight: 400;
  line-height: 17.6px;
  margin-bottom: 10px;
`;

export const TextWrapper = styled.div`
  font-size: 22px;
  font-weight: 400;
  line-height: 17.6px;
  margin-bottom: 10px;
`;
